/*
 * @Author: liuchen
 * @Deion:
 * @Date: 2022-03-30 10:40:24
 * @LastEditTime: 2025-03-08 17:47:36
 */
import Vue from 'vue'
import router from './router/index'
// import VueAxios from 'vue-axios'
import iView from 'view-design'
import 'iview/dist/styles/iview.css'
import './../public/statics/css/reset.css'
// 各API接口
import api from './api/api' // 导入api接口
// 首页模板
import App from './components/console/App.vue'
// 状态管理
import store from './vuex/store'
import util from "./utils/index";
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

Vue.use(iView)
Vue.config.productionTip = false
Vue.prototype.$api = api // 将api挂载到vue的原型上
Vue.prototype.$util = util;// 将工具类挂载到vue的原型上
Vue.use(Viewer)
const publicData = {
  // serverUrl: "http://localhost:8096/common/ueditor_upload", // 本地
  //   serverUrl: "http://timemap2_laravel.shanmuzhi.com/common/ueditor_upload", // 测试服
  // serverUrl: "http://admin.shidaijiyi.com/common/ueditor_upload", //线上
  // imageUrl: "http://timemap2_laravel.shanmuzhi.com", // 测试
  // H5Url: "https://tmall-new.shanmuzhi.com", // 测试
  imageUrl: 'https://jinfeixibi.tianwu.net.cn/', // 线上
  H5Url: 'https://jinfeixibi.tianwu.net.cn', // 线上
  serverUrl: 'https://jinfeixibi.tianwu.net.cn/common/ueditor_upload', // 线上
  ossUrl: 'https://gaoqiualbum.oss-cn-beijing.aliyuncs.com/' // oss
}
Vue.prototype.$publicData = publicData
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
